import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function PanelAgenda(props) {
    return (
        <Fragment><br />
            <div className='container'>
                <h1>Agenda</h1>
                <br></br>
                <div className='row'>
                    <div className='col-6 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xxl-4 text-center'>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto eum nostrum at delectus excepturi possimus fuga ab obcaecati porro ex consequuntur consequatur, cupiditate, amet asperiores sequi quaerat perspiciatis! Perferendis.</p>
                    </div>
                    <div className='col-6 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xxl-4 text-center'>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto eum nostrum at delectus excepturi possimus fuga ab obcaecati porro ex consequuntur consequatur, cupiditate, amet asperiores sequi quaerat perspiciatis! Perferendis.</p>
                    </div>
                    <div className='col-6 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xxl-4 text-center'>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto eum nostrum at delectus excepturi possimus fuga ab obcaecati porro ex consequuntur consequatur, cupiditate, amet asperiores sequi quaerat perspiciatis! Perferendis.</p>
                    </div>
                    <div className='col-6 col-xs-12 col-sm-12 col-md-4 col-lg-6 col-xxl-4 text-center'>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto eum nostrum at delectus excepturi possimus fuga ab obcaecati porro ex consequuntur consequatur, cupiditate, amet asperiores sequi quaerat perspiciatis! Perferendis.</p>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12 col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xxl-8 text-center'>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto eum nostrum at delectus excepturi possimus fuga ab obcaecati porro ex consequuntur consequatur, cupiditate, amet asperiores sequi quaerat perspiciatis! Perferendis.</p>
                    </div>
                    <div className='col-12 col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xxl-4 text-center'>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Rerum architecto eum nostrum at delectus excepturi possimus fuga ab obcaecati porro ex consequuntur consequatur, cupiditate, amet asperiores sequi quaerat perspiciatis! Perferendis.</p>
                    </div>
                </div>

                <div className='row'>
                    <button className='btn btn-success'>Dame click</button>
                    <input className='form-control' type="date" name="" id="" />
                    <input className='form-control' type="text" name="" id="" />
                </div>

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item active" aria-current="page">Home</li>
                    </ol>
                </nav>

                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Library</li>
                    </ol>
                </nav>


            </div>



        </Fragment>
    );
};


export default withRouter(PanelAgenda)
